import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Helps } from 'src/app/libs/helps';
import { Paginate } from 'src/app/models/interfaces/paginate';
import { ApiEntryControlService } from '../../../api-entry-control.service';
import { Visitors } from '../../../interfaces/visitors';
import { Cars } from '../../../interfaces/cars';

@Component({
  selector: 'app-list-cars',
  templateUrl: './list-cars.component.html',
  styleUrl: './list-cars.component.css'
})
export class ListCarsComponent implements OnInit, OnChanges {

  error: any;
  constructor(
    private api: ApiEntryControlService,
    private modal: NgbModal,
    private toast: ToastrService,
    private router: Router,
    private helps:Helps
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    localStorage.removeItem('endPoint');
    localStorage.setItem('endPoint',"3");
    if(changes['storesId'].currentValue!=this.storesId){
      localStorage.removeItem('stores_id');
      localStorage.setItem('stores_id',this.storesId.toString());
      this.get();
    }
  }
  view: number = 1;
  status: any;
  selected?: Cars;
  level:number;
  ngOnInit(): void {
    this.level=this.helps.getToken()?.level;
    localStorage.removeItem('endPoint');
    localStorage.setItem('endPoint',"3");
    localStorage.removeItem('stores_id');
    localStorage.setItem('stores_id',this.storesId.toString());
    this.get();
  }
  @Input()
  storesId: number;

  items: Cars[];
  page = 1;
  perpage: number = 0;
  collectionSize = 0;
  totalPage = 0;

  brands: any;
  secondForm = new UntypedFormGroup({
    id: new UntypedFormControl(),
  });
  form = new UntypedFormGroup({
    q: new UntypedFormControl(''),
    state_id: new UntypedFormControl('')
  });
  delete() {
    this.secondForm.get('id')?.setValue(this.selected?.id);
    this.api.deleteCars(this.secondForm).subscribe(
      (res) => {
        this.toast.success('Vehículo eliminado correctamente', 'VEHÍCULOS');
        this.get();
        this.modal.dismissAll();
      },
      (e) => {
        this.toast.warning(e.error.mistakes, e.msg,{enableHtml:true,closeButton:true});
      }
    );
  }
  get() {
    this.api.paginateCars(this.page, this.storesId, this.form).subscribe(
      (response) => {
        var data = response.data as Paginate;
        this.items = data.items as Cars[];
        this.page = data.current;
        this.perpage = data.per_page;
        this.collectionSize = data.count;

        this.totalPage = data.total;
      },
      (error) => {
        this.items = null;
        this.page = 1;
        this.collectionSize = 0;
        this.totalPage = 0;
        this.toast;
      }
    );
  }
  openModal(md:any, size: string = 'md') {
    this.modal.open(md, {
      size: size,
    });
  }
  openDelete(item: any, md: any) {
    this.selected = item;
    this.modal.open(md, {
      size: 'md',
    });
  }
  openEdit(item: any, md: any) {
    console.log("Llego:",item);
    this.selected = item;
    this.modal.open(md, {
      size: 'md',
    });
  }
  search(val?: string) {
    if (val !== undefined) {
      this.form.get('q')?.setValue(val);
    }
    this.page = 1;
    this.get();
  }
  filterChange() {
    this.page = 1;
    this.get();
  }
  clean() {
    this.form.reset();
    this.page = 1;
    this.get();
  }
}

